export default {
  manage_sellables: "Gerenciar produtos e kits",
  manage_customers: "Gerenciar clientes",
  manage_users: "Gerenciar usuários",
  manage_category: "Gerenciar categorias",
  view_open_sales: "Realizar vendas em aberto",
  view_closed_sales: "Visualizar o histórico de vendas",
  view_cash_register_sales: "Visualizar vendas somente no caixa aberto",
  add_discount: "Adicionar descontos",
  manage_own_company: "Gerenciar minha empresa",
  manage_own_profile: "Gerenciar a própria conta",
  manage_companies: "Gerenciar empresas",
  view_cash_register_reports: "Visualizar histórico de caixas",
  manage_features: "Gerenciar funcionalidades"
};



// WEBPACK FOOTER //
// ./src/core/enum/user-permissions.enum.js